import React from "react"

import DarkModeContextProvider from "../../context/DarkModeContext"
import CookiesContextProvider from "../../context/CookiesContext"

export default function AppContainer({ children }) {
  return (
    <>
      <CookiesContextProvider>
        <DarkModeContextProvider>{children}</DarkModeContextProvider>
      </CookiesContextProvider>
    </>
  )
}
